module.exports = __webpack_public_path__ + "static/img/jcyc2.b40abf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/jcyc2.png
// module id = 9bCg
// module chunks = 0